import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { LoadUser } from '../../state/user-form.actions';
import { UserFormState } from '../../state/user-form.state';

@Injectable({ providedIn: 'root' })
export class UserGuard implements CanActivate {
  constructor(private store: Store) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(UserFormState.user).pipe(
      take(1),
      map(({ data }) => data?.id),
      tap(id => {
        if (id === route.params.id) {
          return;
        }

        this.store.dispatch([new LoadUser(route.params.id)]);
      }),
      map(() => true)
    );
  }
}
